<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3">
            <label>{{ $t('common_words.farm') }}: *</label>
            <br />
            <el-select
              clearable
              @clear="cleanFarm()"
              filterable
              class="select-primary custom-width-select shadow-sm required-farm"
              v-model="farm_id"
              size="large"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in farms"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
            <br class="media-none" />
            <label>{{ $t('common_words.date') }}: *</label>
            <br />
            <el-date-picker
              v-if="renderComponent"
              :picker-options="pickerOptions"
              class="shadow-sm required-date"
              v-model="date_sel"
              value-format="yyyy-MM-dd"
              :placeholder="`${$t('common_words.select2')}...`"
            />
          </div>
          <div class="col-12 col-md-4 col-xl-2">
            <br class="media-none" />
            <label class="label-primary" style="color: transparent">{{
              $t('common_words.filter')
            }}</label
            ><br />
            <l-button wide type="info" class="btn-filter" @click="validate">
              {{ $t('common_words.filter') }}
            </l-button>
          </div>
        </div>
        <br />
      </card>
      <div v-if="messageAlert" class="alert alert-warning" role="alert">
        {{ messageAlert }}
      </div>
      <card
        class="custom-shadow-card-header"
        v-if="cutting"
        title="Kilogramos Cosechados"
      >
        <div class="mt-4">
          <div class="row" v-if="isIndex() && (isCreate() || isUpdate())">
            <table
              aria-describedby="tabla-cosechados"
              class="table table-striped table-bordered"
              v-if="lotsData.length > 0"
            >
              <thead>
                <tr class="cusmtom-thead-color">
                  <th
                    scope="col"
                    class="text-center p-3 custom-header-label"
                    v-bind:style="{ minWidth: '200px' }"
                  >
                    <strong>{{ $t('common_words.allotment') }}</strong>
                  </th>
                  <th
                    scope="col"
                    class="text-center p-3 custom-header-label"
                    v-bind:style="{ minWidth: '200px' }"
                  >
                    <strong>{{ $t('common_words.variety') }}</strong>
                  </th>
                  <th
                    scope="col"
                    class="text-center p-3 custom-header-label"
                    v-bind:style="{ minWidth: '150px' }"
                  >
                    <strong>{{ $t('common_words.area_roamed') }} (ha)</strong>
                  </th>
                  <th
                    scope="col"
                    class="text-center custom-header-label"
                    v-bind:style="{ width: '150px' }"
                  >
                    <strong>{{ $t('common_words.gross_weight') }} (Kg)</strong>
                  </th>
                  <th
                    scope="col"
                    class="text-center custom-header-label"
                    v-bind:style="{ width: '150px' }"
                  >
                    <strong>{{ $t('common_words.net_weight') }} (Kg)</strong>
                  </th>
                  <th
                    v-if="!messageAlert"
                    scope="col"
                    class="text-center custom-header-label"
                    v-bind:style="{ width: '100px', marginTop: '6px' }"
                  >
                    <strong>{{ $t('common_words.options') }}</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(lot, i) in cuttingForm.nCutting" :key="i">
                  <td class="text-center">
                    <el-select
                      clearable
                      filterable
                      width="10"
                      class="select-primary custom-width-select required-cutting-lots shadow-sm"
                      modelName="cutting-lots"
                      size="medium"
                      v-model="cuttingForm.lots_sel[i]"
                      :placeholder="`${$t('common_words.select')}...`"
                      @change="onSelectCuttingLot($event, i)"
                      @clear="cleanLineFields('cleanRejectionLine')"
                    >
                      <el-option
                        v-for="l in lots"
                        class="select-primary"
                        :value="l.id"
                        :label="l.name"
                        :key="l.id"
                      ></el-option>
                    </el-select>
                  </td>
                  <td class="text-center">
                    <el-select
                      clearable
                      filterable
                      width="10"
                      class="select-primary custom-width-select required-variety shadow-sm"
                      modelName="variety"
                      size="medium"
                      v-model="cuttingForm.crop_varieties_sel[i]"
                      :placeholder="`${$t('common_words.select')}...`"
                      @change="onCropVarietyCutting($event, i)"
                      @clear="cleanLineFields('cleanRejectionLine')"
                    >
                      <el-option
                        v-for="l in cropVarieties"
                        class="select-primary"
                        :value="l.id"
                        :label="l.name"
                        :key="l.id"
                      ></el-option>
                    </el-select>
                  </td>
                  <td class="text-center">
                    <el-input
                      type="number"
                      clearable
                      min="0"
                      maxlength="4"
                      step="0.1"
                      class="text-center input-covered_area required-covered-area"
                      modelName="covered-area"
                      @change="onCoveredAreaCutting($event, i)"
                      v-model="cuttingForm.covered_area[i]"
                    >
                      <template slot="append">(ha)</template>
                    </el-input>
                  </td>
                  <td class="text-center">
                    <el-input
                      type="number"
                      clearable
                      min="0"
                      maxlength="4"
                      step="0.1"
                      class="text-center input-gross_weight required-gross-weight"
                      modelName="gross-weight"
                      @change="onGrossWeightCutting($event, i)"
                      v-model="cuttingForm.gross_weight[i]"
                    >
                    </el-input>
                  </td>
                  <td class="text-center">
                    <el-input
                      type="number"
                      clearable
                      min="0"
                      maxlength="4"
                      step="0.1"
                      class="text-center input-net_weight required-net-weight"
                      modelName="net-weight"
                      @change="onNetWeightCutting($event, i)"
                      v-model="cuttingForm.net_weight[i]"
                    >
                    </el-input>
                  </td>
                  <td
                    v-if="!messageAlert"
                    class="text-center"
                    style="display: table-cell"
                    v-bind:style="{ width: '100px' }"
                  >
                    <div class="d-flex justify-content-center mt-3">
                      <a
                        v-if="isUpdate()"
                        v-tooltip.top-center="$t('common_words.add')"
                        class="btn-warning btn-simple btn-link custom-margin-actions"
                        @click.prevent="addLotData()"
                      >
                        <em class="fa fa-plus custom-size-fa-actions"></em>
                      </a>
                      <a
                        v-if="cuttingForm.nCutting > 1 && isDelete()"
                        v-tooltip.top-center="$t('common_words.erase')"
                        class="btn-danger btn-simple btn-link custom-margin-actions"
                        @click="handleDelete(i)"
                      >
                        <em class="fa fa-times custom-size-fa-actions"></em>
                      </a>
                    </div>
                  </td>
                </tr>
                <tr class="text-center">
                  <td colspan="3" class="text-muted text-center">
                    <strong>{{ $t('common_words.total_mayus') }}</strong>
                  </td>
                  <td>{{ totalGrossWeight }}</td>
                  <td>{{ totalNetWeight }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions_module') }}
            </h5>
          </div>
          <div v-if="!messageAlert" class="row">
            <div class="col-6 text-right" v-if="isCreate() || isUpdate()">
              <l-button
                wide
                type="info"
                class="btn-filter m-4"
                v-on:click="validateCuttingForm()"
              >
                {{ $t('common_words.save') }}
              </l-button>
            </div>
            <div class="col-6 text-left" v-if="isDelete()">
              <l-button
                wide
                type="danger"
                class="btn-filter m-4"
                @click="deleteCuttingDetails()"
              >
                {{ $t('common_words.delete') }}
              </l-button>
            </div>
          </div>
        </div>
      </card>
      <div v-if="messageAlert" class="alert alert-warning" role="alert">
        {{ messageAlert }}
      </div>
      <card
        class="custom-shadow-card-header"
        v-if="cutting"
        title="Kilogramos Rechazados"
      >
        <div class="mt-4">
          <div
            class="row"
            style="overflow-x: auto"
            v-if="isIndex() && (isCreate() || isUpdate())"
          >
            <table
              style="width: 100%; white-space: nowrap"
              aria-describedby="tabla-recusados"
              class="table table-striped table-bordered"
              v-if="lotsRejectionsData.length > 0"
            >
              <thead>
                <tr class="cusmtom-thead-color">
                  <th
                    scope="col"
                    class="text-center p-3 custom-header-label"
                    v-bind:style="{ minWidth: '150px' }"
                  >
                    <strong>{{ $t('common_words.allotment') }}</strong>
                  </th>
                  <th
                    scope="col"
                    class="text-center p-3 custom-header-label"
                    v-bind:style="{ minWidth: '150px' }"
                  >
                    <strong>{{ $t('production.rejection_motive') }}</strong>
                  </th>
                  <th
                    scope="col"
                    class="text-center custom-header-label"
                    v-bind:style="{ width: '200px' }"
                  >
                    <strong>{{ $t('common_words.weight') }} (Kg)</strong>
                  </th>
                  <th
                    v-if="!messageAlert"
                    scope="col"
                    class="text-center custom-header-label"
                    v-bind:style="{ width: '100px', marginTop: '6px' }"
                  >
                    <strong>{{ $t('common_words.options') }}</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(lot, i) in rejectionsForm.nCuttingRejections"
                  :key="i"
                >
                  <td class="text-center">
                    <el-select
                      clearable
                      filterable
                      class="select-primary custom-width-select required-rejections-lots shadow-sm"
                      size="medium"
                      v-model="rejectionsForm.lots_rejections_sel[i]"
                      :placeholder="`${$t('common_words.select')}...`"
                      @change="onSelectRejectionsChange($event, i, 'id')"
                    >
                      <el-option
                        v-for="l in availableRejectionsLots"
                        class="select-primary"
                        :value="l.id"
                        :label="l.name"
                        :key="l.id"
                      ></el-option>
                    </el-select>
                  </td>
                  <td class="text-center">
                    <el-select
                      clearable
                      filterable
                      class="select-primary custom-width-select required-rejections-reasons shadow-sm"
                      size="medium"
                      v-model="rejectionsForm.rejections_sel[i]"
                      :placeholder="`${$t('common_words.select')}...`"
                      @change="onSelectRejectionsChange($event, i, 'rejection')"
                    >
                      <el-option
                        v-for="r in rejections"
                        class="select-primary"
                        :value="r.id"
                        :label="r.name"
                        :key="r.id"
                      ></el-option>
                    </el-select>
                  </td>
                  <td class="text-center">
                    <el-input
                      type="number"
                      clearable
                      min="0"
                      maxlength="4"
                      step="0.1"
                      class="text-center input-rejection_weight"
                      v-model="rejectionsForm.weight[i]"
                    >
                    </el-input>
                  </td>
                  <td
                    v-if="!messageAlert"
                    class="text-center"
                    style="display: table-cell"
                    v-bind:style="{ width: '100px' }"
                  >
                    <div class="d-flex justify-content-center mt-3">
                      <a
                        v-if="isUpdate()"
                        v-tooltip.top-center="$t('common_words.add')"
                        class="btn-warning btn-simple btn-link custom-margin-actions"
                        @click.prevent="addLotRejectionsData()"
                      >
                        <em class="fa fa-plus custom-size-fa-actions"></em>
                      </a>
                      <a
                        v-if="
                          rejectionsForm.nCuttingRejections > 1 && isDelete()
                        "
                        v-tooltip.top-center="$t('common_words.erase')"
                        class="btn-danger btn-simple btn-link custom-margin-actions"
                        @click="handleRejectionsDelete(i)"
                      >
                        <em class="fa fa-times custom-size-fa-actions"></em>
                      </a>
                    </div>
                  </td>
                </tr>
                <tr class="text-center">
                  <td colspan="2" class="text-muted text-center">
                    <strong>{{ $t('common_words.total_mayus') }}</strong>
                  </td>

                  <td>{{ totalRejectionWeight }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions_module') }}
            </h5>
          </div>
          <div v-if="!messageAlert" class="row">
            <div class="col-6 text-right" v-if="isCreate() || isUpdate()">
              <l-button
                wide
                type="info"
                class="btn-filter m-4"
                v-on:click="saveRejections()"
              >
                {{ $t('common_words.save') }}
              </l-button>
            </div>
            <div class="col-6 text-left" v-if="isDelete()">
              <l-button
                wide
                type="danger"
                class="btn-filter m-4"
                @click="deleteRejectionDetails()"
              >
                {{ $t('common_words.delete') }}
              </l-button>
            </div>
          </div>
        </div>
      </card>
      <div v-if="!messageAlert" class="row">
        <div
          class="col-12 text-center"
          v-if="cutting && (isCreate() || isUpdate())"
        >
          <l-button
            wide
            type="info"
            class="btn-filter m-4"
            v-on:click="saveAll()"
          >
            {{ $t('common_words.save_all') }}
          </l-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import { getRepeatsFromArray } from 'src/util/Util.js';
import { mapActions } from 'vuex';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

export default {
  mixins: [MixinPermissions, mixinMasters, MixinMenu],
  data() {
    return {
      farm_id: null,
      date_sel: null,

      fruit_harvest_header_id: null,
      has_details: false,
      has_rejections: false,

      cuttingForm: {
        user_id: this.$store.state.auth.user.id,
        lots_sel: [],
        crop_varieties_sel: [],
        covered_area: [],
        gross_weight: [],
        net_weight: [],
        nCutting: 1,

        forDelete: [],
        updating: false,
      },
      rejectionsForm: {
        user_id: this.$store.state.auth.user.id,
        lots_rejections_sel: [],
        rejections_sel: [],
        weight: [],
        nCuttingRejections: 1,

        forRejectionsDelete: [],
        updating: false,
      },

      lotsData: [
        {
          id: null,
          crop_variety: null,
          covered_area: 0,
          gross_weight: 0,
          net_weight: 0,
        },
      ],
      lotsRejectionsData: [
        {
          id: null,
          rejection_id: null,
          weight: 0,
        },
      ],

      relationLotRejections: [],
      cutting: false,
      isCuttingSave: false,
      isRejectionSave: true,
      farms: [],
      cropVarieties: [],
      lots: [],
      rejections: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      isSaveAll: false,
      messageAlert: null,
    };
  },
  computed: {
    availableLots() {
      return this.lots.filter(
        (lot) => !this.cuttingForm.lots_sel.includes(lot.id)
      );
    },

    availableRejectionsLots() {
      return this.lots.filter((lot) =>
        this.cuttingForm.lots_sel.includes(lot.id)
      );
    },

    totalGrossWeight() {
      const total = this.cuttingForm.gross_weight.reduce(
        (sum, weight) => sum + Number(weight),
        0
      );

      return parseFloat(total.toFixed(2));
    },

    totalNetWeight() {
      const total = this.cuttingForm.net_weight.reduce(
        (sum, weight) => sum + Number(weight),
        0
      );

      return parseFloat(total.toFixed(2));
    },

    totalRejectionWeight() {
      const total = this.rejectionsForm.weight.reduce(
        (sum, weight) => sum + Number(weight),
        0
      );

      return parseFloat(total.toFixed(2));
    },
  },
  watch: {
    '$i18n.locale': 'forceRerender',
  },

  methods: {
    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    cleanLineFields(option) {
      if (option === 'cleanRejectionLine') {
        this.rejectionsForm.lots_rejections_sel.forEach((lot, lotIndex) => {
          if (lot === null) {
            this.rejectionsForm.lots_rejections_sel[lotIndex] = null;
          }
        });
      }
    },

    async updateGangLotsData(value, index) {
      if (parseInt(value) >= 0 && !isNaN(value)) {
        let error = await this.relationLotGangs.includes(
          `${this.cuttingForm.lots_sel[index]} - ${value}`
        );
        if (error) {
          SweetAlert.warning(
            `${i18n.t('sweet_alert.production.duplicated_error')} ${index + 1}.`
          );
          this.lotsData[index]['gang'] = 0;
        } else {
          this.lotsData[index]['gang'] = value;
        }
        if (this.lotsData[index] && this.lotsData[index]['id'])
          this.relationLotGangs[
            index
          ] = `${this.cuttingForm.lots_sel[index]} - ${value}`;
        else this.relationLotGangs[index] = `id - ${value}`;
      } else {
        this.$set(this.cuttingForm.gang, index, 0);
        this.lotsData[index]['gang'] = 0;
      }

      this.isCuttingSave = false;
    },

    onSelectCuttingLot(value, lot_index) {
      this.lotsData[lot_index].id = value;
    },

    onCropVarietyCutting(value, lot_index) {
      this.lotsData[lot_index].crop_variety = value;
    },

    onCoveredAreaCutting(value, lot_index) {
      this.lotsData[lot_index].covered_area = value;
    },

    onGrossWeightCutting(value, lot_index) {
      this.lotsData[lot_index].gross_weight = value;
    },

    onNetWeightCutting(value, lot_index) {
      this.lotsData[lot_index].net_weight = value;
    },

    onSelectLot(value, lot_index) {
      this.relationLotRejections.forEach((element, i) => {
        if (element.includes(this.lotsData[lot_index]['id'] + ' - ')) {
          this.rejectionsForm.lots_rejections_sel[i] = null;
          element.replace(this.lotsData[lot_index]['id'] + ' - ', 'id - ');
        }
      });

      this.lotsData[lot_index]['covered_area'] = this.cuttingForm.covered_area[
        lot_index
      ]
        ? this.cuttingForm.covered_area[lot_index]
        : 0;

      if (this.lotsData[lot_index]['id'] == null) {
        this.lotsData[lot_index]['id'] = value;
      } else {
        this.lotsData[lot_index]['id_replace'] = value;
      }

      const idDetail = this.lotsData[lot_index]['id_detail'];
      if (
        idDetail !== null &&
        idDetail !== '' &&
        this.cuttingForm.forDelete.includes(idDetail)
      ) {
        this.lotsData[lot_index]['id'] = value;
        this.cuttingForm.forDelete = this.cuttingForm.forDelete.filter(
          (element) => element != idDetail
        );
      }
    },

    updateAreaLotsData(value, index) {
      if (parseInt(value) >= 0 && !isNaN(value)) {
        this.lotsData[index]['covered_area'] = value;
      } else {
        this.$set(this.cuttingForm.covered_area, index, 0);
        this.lotsData[index]['covered_area'] = 0;
      }
    },

    onSelectRejectionsChange(value, index, field) {
      if (field === 'id') {
        const rlr = this.relationLotRejections[index];
        const newValue =
          value && (value == '' || value.length == 0) ? 'id' : value;

        if (rlr && rlr.includes('id - '))
          this.relationLotRejections[index] = rlr.replace('id', newValue);
        else {
          if (rlr && rlr.includes(' - rejection'))
            this.relationLotRejections[index] = newValue + ' - rejection';
          else {
            const splits = rlr ? rlr.split(' - ') : '';
            this.relationLotRejections[index] = splits[1]
              ? (newValue === '' ? 'id' : newValue) + ' - ' + splits[1]
              : newValue + ' - rejection';
          }
        }
      }

      if (field === 'rejection') {
        const rlr = this.relationLotRejections[index];
        const newValue =
          value && (value === '' || value.length === 0) ? 'rejection' : value;

        if (rlr && rlr.includes(' - rejection'))
          this.relationLotRejections[index] = rlr.replace(
            'rejection',
            newValue
          );
        else {
          if (rlr && rlr.includes('id - '))
            this.relationLotRejections[index] = 'id - ' + newValue;
          else {
            const splits = rlr ? rlr.split(' - ') : '';
            this.relationLotRejections[index] = splits[0]
              ? splits[0] + ' - ' + (newValue === '' ? 'rejection' : newValue)
              : 'id - ' + newValue;
          }
        }
      }

      if (this.lotsRejectionsData[index][field] == null) {
        this.lotsRejectionsData[index][field] = value;
      } else {
        this.lotsRejectionsData[index][field + '_replace'] = value;
      }

      const idDetail = this.lotsRejectionsData[index]['id_detail'];
      if (
        idDetail !== null &&
        idDetail !== '' &&
        this.rejectionsForm.forRejectionsDelete.includes(idDetail)
      ) {
        this.lotsRejectionsData[index][field] = value;
        this.rejectionsForm.forRejectionsDelete =
          this.rejectionsForm.forRejectionsDelete.filter(
            (element) => element != idDetail
          );
      }
    },

    /**
     * Limpia la información referente a la finca
     */
    cleanFarm() {
      this.messageAlert = null;
      this.farm_id = null;
    },

    cleanForm() {
      this.relationLotRejections = [];
      this.fruit_harvest_header_id = null;

      this.cuttingForm.lots_sel = [];
      this.cuttingForm.crop_varieties_sel = [];
      this.cuttingForm.covered_area = [];
      this.cuttingForm.gross_weight = [];
      this.cuttingForm.net_weight = [];
      this.cuttingForm.nCutting = 1;
      this.lotsData = [
        {
          id: null,
          crop_variety: null,
          covered_area: 0,
          gross_weight: 0,
          net_weight: 0,
        },
      ];
    },

    cleanRejectionsForm() {
      this.rejectionsForm.updating = false;
      this.fruit_harvest_header_id = null;

      this.relationLotRejections = [];

      this.rejectionsForm.lots_rejections_sel = [];
      this.rejectionsForm.rejections_sel = [];
      this.rejectionsForm.weight = [];

      this.rejectionsForm.nCuttingRejections = 1;
      this.lotsRejectionsData = [
        {
          id: null,
          rejection_id: null,
          weight: 0,
        },
      ];
    },

    validate() {
      if (this.farm_id == null) {
        return this.validationInputsRequired('farm');
      } else if (this.date_sel == null) {
        return this.validationInputsRequired('date');
      } else {
        this.messageAlert = null;
        this.loadCuttings();
        this.cleanForm();
      }
    },

    /* validateCuttingForm() {
      const msgLot = i18n.t('message.production.select_allotment');
      const msgNotUnique = `${i18n.t(
        'sweet_alert.production.duplicated_error'
      )} `;

      if (this.cuttingForm.nCutting != this.cuttingForm.lots_sel.length) {
        SweetAlert.warning(msgLot);
        return this.validationInputsRequired('lots');
      } else {
        this.validateLotsCutting()
          .then(() => {
            return this.validateLotsCoveredArea()
              .then(() => {
                return true;
              })
              .catch(() => {
                return false;
              });
          })
          .catch(() => {
            return false;
          });
      }
    }, */

    async validateCuttingForm(showAlert = true) {
      try {
        await Promise.all([
          this.validateLotsCutting(),
          this.validateVarietiesCutting(),
          this.validateCoveredArea(),
          this.validateGrossWeight(),
          this.validateNetWeight(),
        ]);

        this.saveCutting(showAlert);

        return true; // Todas las validaciones pasaron
      } catch (error) {
        SweetAlert.warning(error);
        return false; // Alguna validación falló
      }
    },

    /**
     * Verifica si existen datos escritos en la tabla de
     * recusados para el guardado
     */
    checkIfThereNotDataInRejectionsTable() {
      const isEmptyRejectionLots =
        this.rejectionsForm.lots_rejections_sel.filter(
          (lot) => lot !== null && lot !== ''
        ).length === 0;
      const isEmptyRejection =
        this.rejectionsForm.rejections_sel.filter(
          (rejection) => rejection !== null && rejection !== ''
        ).length === 0;

      let isEmptyWeeks = true;
      this.lotsRejectionsData.forEach((_, i) => {
        this.lotsRejectionsData[i]['weeks'].forEach((_, j) => {
          if (
            this.lotsRejectionsData[i]['weeks'][j]['value'] !== null &&
            Number.isInteger(
              parseInt(this.lotsRejectionsData[i]['weeks'][j]['value'])
            )
          ) {
            isEmptyWeeks = false;
          }
        });
      });

      return isEmptyRejectionLots && isEmptyRejection && isEmptyWeeks;
    },

    validateRejectionsForm(checkDataInRejectionsTable = false) {
      this.validateLinesTotalArea()
        .then(() => {
          return this.validateLinesCutting()
            .then(() => {
              const msgLot = i18n.t('message.production.info_allotment');
              const msgRejection = i18n.t('message.production.info_rejected');
              const msgNotUnique = i18n.t(
                'message.production.allotment_rejected'
              );
              const msgNotChange = i18n.t('message.production.pending_changes');
              const msgNotSave = i18n.t('message.production.save_crop');

              if (
                checkDataInRejectionsTable &&
                this.checkIfThereNotDataInRejectionsTable()
              ) {
                this.cleanForm();
                this.cleanRejectionsForm();
                this.cutting = false;
                this.showHideLoading();
              } else {
                if (
                  this.rejectionsForm.nCuttingRejections !=
                  this.rejectionsForm.lots_rejections_sel.filter(
                    (lot) => lot !== null && lot !== ''
                  ).length
                ) {
                  SweetAlert.warning(msgLot);
                  return this.validationInputsRequired('rejections-lots');
                } else {
                  if (
                    this.rejectionsForm.nCuttingRejections !=
                    this.rejectionsForm.rejections_sel.filter(
                      (reject) => reject !== null && reject !== ''
                    ).length
                  ) {
                    SweetAlert.warning(msgRejection);
                    return this.validationInputsRequired('rejections-reasons');
                  } else {
                    if (
                      getRepeatsFromArray(this.relationLotRejections).length > 0
                    ) {
                      SweetAlert.warning(msgNotUnique);
                    } else {
                      if (this.cuttingForm.updating) {
                        SweetAlert.warning(msgNotChange);
                      } else {
                        return this.validateLinesRejections()
                          .then(() => {
                            if (!this.cuttingForm.updating)
                              SweetAlert.warning(msgNotSave);
                            else this.saveRejections();
                          })
                          .catch((error) => {
                            this.isSaveAll = false;
                            this.showMessageValidationsRejections(
                              error,
                              'rejection'
                            );
                          });
                      }
                    }
                  }
                }
              }
            })
            .catch((error) => {
              this.showMessageValidationsRejections(error, 'cutting');
            });
        })
        .catch((error) =>
          SweetAlert.warning(
            `${i18n.t('sweet_alert.production.digited_area')}${
              error[0] + 1
            }, ${i18n.t('sweet_alert.production.cannot_be_greater_than')}"${
              error[1]
            }(ha)", ${i18n.t('sweet_alert.production.check_info')}`
          )
        );
    },

    showMessageValidationsRejections(error, type = 'cutting') {
      let msgOne = '';
      let msgTwo = '';
      let msgThree = '';

      if (type === 'cutting') {
        msgOne = i18n.t('message.production.missing_allotment_info');
        msgTwo = `${i18n.t('message.production.duplicated_error')} ${
          error * -1
        }.`;
        msgThree = `${i18n.t('message.production.missing_crop_info')} `;
      } else {
        msgOne = i18n.t('message.production.missing_allotment_table_info');
        msgTwo = i18n.t('message.production.missing_rejected_info');
        msgThree = `${i18n.t(
          'message.production.missing_inputed_rejected_info'
        )}`;
      }

      switch (error) {
        case -1:
          SweetAlert.warning(msgOne);
          break;

        case -2:
          SweetAlert.warning(msgTwo);
          break;

        default:
          SweetAlert.warning(`${msgThree} ${error + 1}`);
          break;
      }
    },

    /**
     * Validar cada línea asegurándose de que un campo específico esté seleccionado
     * @param {String} field - Campo a validar (ejemplo: 'lots_sel', 'crop_varieties_sel').
     * @param {String} errorType - Tipo de error para usar en validationInputsRequired.
     * @param {String} inputName - Nombre del label para mostrar el error.
     */
    async validateFieldCutting(
      field,
      errorType,
      inputName,
      validateLotsArea = false
    ) {
      return new Promise((resolve, reject) => {
        for (let i = 0; i < this.lotsData.length; i++) {
          if (
            this.cuttingForm[field][i] === undefined ||
            this.cuttingForm[field][i] === ''
          ) {
            this.validationInputsRequired(errorType);

            reject(
              `Error en el registro ${i + 1}, verifique el campo ${inputName}`
            );
            return;
          }

          if (validateLotsArea) {
            const lotData = this.lotsData[i];
            const lotInfo = this.lots.find((lot) => lot.id === lotData.id);

            if (Number(lotData.covered_area) > Number(lotInfo.area)) {
              reject(
                `${i18n.t('sweet_alert.production.digited_area')}${
                  i + 1
                }, ${i18n.t('sweet_alert.production.cannot_be_greater_than')}"${
                  lotInfo.area
                }(ha)`
              );
              return;
            }
          }
        }
        resolve();
      });
    },

    async validateLotsCutting() {
      return this.validateFieldCutting(
        'lots_sel',
        'cutting-lots',
        i18n.t('common_words.allotment')
      );
    },

    async validateVarietiesCutting() {
      return this.validateFieldCutting(
        'crop_varieties_sel',
        'variety',
        i18n.t('common_words.variety')
      );
    },
    async validateCoveredArea() {
      return this.validateFieldCutting(
        'covered_area',
        'covered-area',
        i18n.t('common_words.area_roamed'),
        true
      );
    },
    async validateGrossWeight() {
      return this.validateFieldCutting(
        'gross_weight',
        'gross-weight',
        i18n.t('common_words.gross_weight')
      );
    },
    async validateNetWeight() {
      return this.validateFieldCutting(
        'net_weight',
        'net-weight',
        i18n.t('common_words.net_weight')
      );
    },

    async validateLinesRejections() {
      return new Promise((resolve, reject) => {
        for (let i = 0; i < this.lotsRejectionsData.length; i++) {
          if (
            this.rejectionsForm.lots_rejections_sel[i] === undefined ||
            this.rejectionsForm.lots_rejections_sel[i] === ''
          ) {
            this.validationInputsRequired('rejections-lots');
            reject(-1);
          }

          if (
            this.rejectionsForm.rejections_sel[i] === undefined ||
            this.rejectionsForm.rejections_sel[i] === ''
          ) {
            this.validationInputsRequired('rejections-reasons');
            reject(-2);
          }

          let band = false;
          for (let j = 0; j < this.lotsRejectionsData[i]['weeks'].length; j++) {
            if (this.lotsRejectionsData[i]['weeks'][j]['value'] !== null) {
              band = true;
              if (
                Number.isInteger(
                  parseInt(this.lotsRejectionsData[i]['weeks'][j]['value'])
                )
              )
                break;
            }

            if (this.lotsRejectionsData[i]['weeks'][j]['value'] === '') {
              band = false;
            }
          }
          if (!band) {
            reject(i);
          }
        }
        resolve();
      });
    },

    updateLotsData(lot_index, week_index, $event) {
      if (!isNaN($event)) {
        let total = 0;
        let totalWeek = 0;
        this.lotsData[lot_index]['weeks'].forEach((item) => {
          if (item.value != null && item.value != '' && item.value != '0') {
            total = total + Number.parseInt(item.value);
          }
        });
        this.lotsData[lot_index]['total'] = total;

        for (let i = 0; i < this.lotsData.length; i = i + 1) {
          for (let j = 0; j < this.lotsData[i]['weeks'].length; j = j + 1) {
            if (j == week_index) {
              if (
                this.lotsData[i]['weeks'][j]['value'] != null &&
                this.lotsData[i]['weeks'][j]['value'] != ''
              ) {
                totalWeek =
                  totalWeek +
                  Number.parseInt(this.lotsData[i]['weeks'][j]['value']);
              }
            }
          }
        }
      } else {
        this.lotsData[lot_index]['weeks'][week_index]['value'] = null;
      }
    },

    updateLotsRejectionsData(lot_index, week_index, $event) {
      if (!isNaN($event)) {
        let total = 0;
        let totalWeek = 0;
        this.lotsRejectionsData[lot_index]['weeks'].forEach((item) => {
          if (item.value != null && item.value != '' && item.value != '0') {
            total = total + Number.parseInt(item.value);
          }
        });
        this.lotsRejectionsData[lot_index]['total'] = total;

        for (let i = 0; i < this.lotsRejectionsData.length; i = i + 1) {
          for (
            let j = 0;
            j < this.lotsRejectionsData[i]['weeks'].length;
            j = j + 1
          ) {
            if (j == week_index) {
              if (
                this.lotsRejectionsData[i]['weeks'][j]['value'] != null &&
                this.lotsRejectionsData[i]['weeks'][j]['value'] != ''
              ) {
                totalWeek =
                  totalWeek +
                  Number.parseInt(
                    this.lotsRejectionsData[i]['weeks'][j]['value']
                  );
              }
            }
          }
        }
      } else {
        this.lotsRejectionsData[lot_index]['weeks'][week_index]['value'] = null;
      }
    },

    addLotData() {
      this.lotsData.push({
        id: null,
        crop_variety: null,
        covered_area: 0,
        gross_weight: 0,
        net_weight: 0,
      });
      this.cuttingForm.nCutting++;
    },

    addLotRejectionsData() {
      this.lotsRejectionsData.push({
        id: null,
        rejection_id: null,
        weight: 0,
      });
      this.rejectionsForm.nCuttingRejections++;
    },

    /* handleDelete(lot_index) {
      console.log('index to delete: ', lot_index);
      this.cuttingForm.nCutting--;
      const toDelete = this.lotsData[lot_index]['id'];
      console.log('toDelete: ', toDelete);

      let toReplace = this.lotsData[lot_index]['id_replace'];

      const nLotsRepeats = this.cuttingForm.lots_sel.filter(
        (lot) => lot === toDelete
      ).length;

      if (toReplace === undefined) toReplace = toDelete;

      if (nLotsRepeats === 1) {
        this.relationLotRejections.forEach((element, i) => {
          if (element.includes(toReplace + ' - ')) {
            this.rejectionsForm.lots_rejections_sel[i] = null;
            element.replace(toReplace + ' - ', 'id - ');
          }
        });
      }

      this.lotsData.splice(lot_index, 1);

      try {
        let tmp = Object.assign([], this.cuttingForm.lots_sel);
        tmp.splice(lot_index, 1);
        setTimeout(() => {
          this.cuttingForm.lots_sel = Object.assign([], tmp);
        }, 5);
      } catch (error) {}

      try {
        this.cuttingForm.covered_area.splice(lot_index, 1);
        let tmp = Object.assign([], this.cuttingForm.covered_area);
        this.cuttingForm.covered_area = [];
        setTimeout(() => {
          this.cuttingForm.covered_area = Object.assign([], tmp);
        }, 5);
      } catch (error) {}

      if (nLotsRepeats === 1) {
        this.showHideLoading(true);
        this.rejectionsDeleteByDeleteCutting();
      }
    }, */

    handleDelete(lotIndex) {
      this.cuttingForm.nCutting--;

      // Eliminar el lote de datos principales y del formulario
      this.removeLotFromData('lots_sel', lotIndex);
      this.removeLotFromData('covered_area', lotIndex);
      this.removeLotFromData('crop_varieties_sel', lotIndex);
      this.removeLotFromData('gross_weight', lotIndex);
      this.removeLotFromData('net_weight', lotIndex);

      // Eliminar el lote del array principal
      this.lotsData.splice(lotIndex, 1);
    },

    removeLotFromData(field, index) {
      try {
        // Crear una copia del campo, eliminar el índice y reasignar
        let tmp = Object.assign([], this.cuttingForm[field]);
        tmp.splice(index, 1);
        this.cuttingForm[field] = [];
        setTimeout(() => {
          this.cuttingForm[field] = Object.assign([], tmp);
        }, 5);
      } catch (error) {
        console.error(`Error updating ${field}: `, error);
      }
    },

    rejectionsDeleteByDeleteCutting() {
      let index = 0;
      for (const lot of this.rejectionsForm.lots_rejections_sel) {
        if (lot === null || lot === '') {
          this.handleRejectionsDelete(index);
          break;
        }
        index++;
      }

      setTimeout(() => {
        if (index < this.rejectionsForm.lots_rejections_sel.length)
          this.rejectionsDeleteByDeleteCutting();
        else {
          if (this.rejectionsForm.nCuttingRejections == 0)
            this.cleanRejectionsForm();
          this.showHideLoading();
        }
      }, 100);
    },

    handleRejectionsDelete(lot_index) {
      this.rejectionsForm.nCuttingRejections--;
      const toDelete = this.lotsRejectionsData[lot_index]['id'];
      let toReplace = this.lotsRejectionsData[lot_index]['id_replace'];

      this.lotsRejectionsData[lot_index]['weeks'].forEach((week) => {
        const idDetail = week['id_detail'];
        if (idDetail !== null && idDetail !== '')
          this.rejectionsForm.forRejectionsDelete.push(idDetail);
      });

      if (toReplace === undefined) toReplace = toDelete;

      this.lotsRejectionsData.splice(lot_index, 1);

      try {
        this.rejectionsForm.lots_rejections_sel.splice(lot_index, 1);
        this.rejectionsForm.rejections_sel.splice(lot_index, 1);
        this.relationLotRejections.splice(lot_index, 1);

        let tmp = Object.assign([], this.rejectionsForm.lots_rejections_sel);
        let tmp_rejections = Object.assign(
          [],
          this.rejectionsForm.rejections_sel
        );
        let tmp_relation = Object.assign([], this.relationLotRejections);

        this.rejectionsForm.lots_rejections_sel = [];
        this.rejectionsForm.rejections_sel = [];
        this.relationLotRejections = [];

        setTimeout(() => {
          this.rejectionsForm.lots_rejections_sel = Object.assign([], tmp);
          this.rejectionsForm.rejections_sel = Object.assign(
            [],
            tmp_rejections
          );
          this.relationLotRejections = Object.assign([], tmp_relation);
        }, 5);
      } catch (error) {}
    },

    async saveCutting(showAlert = true) {
      const data = {
        route: 'cutting/legumecuts',
        farm_id: this.farm_id,
        date_save: this.date_sel,
        user_id: this.cuttingForm.user_id,
        details: this.cuttingForm.lots_sel.map((lotId, index) => ({
          lot_id: lotId,
          crop_variety_id: this.cuttingForm.crop_varieties_sel[index],
          covered_area: this.cuttingForm.covered_area[index] || 0,
          gross_weight: this.cuttingForm.gross_weight[index] || 0,
          net_weight: this.cuttingForm.net_weight[index] || 0,
        })),
      };

      this.showHideLoading(true);
      await Axios.postMasters(data)
        .then((response) => {
          this.showHideLoading();
          this.cleanForm();
          this.cutting = false;
          if (showAlert) {
            SweetAlert.success(response.data.message);
          }
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    },

    async saveRejections(showAlert = true) {
      const data = {
        route: 'cutting/legumecuts/rejections',
        farm_id: this.farm_id,
        date_save: this.date_sel,
        user_id: this.rejectionsForm.user_id,
        details: this.rejectionsForm.lots_rejections_sel.map(
          (lotId, index) => ({
            lot_id: lotId,
            rejection_reason_id: this.rejectionsForm.rejections_sel[index] || 0,
            weight: this.rejectionsForm.weight[index] || 0,
          })
        ),
      };

      this.showHideLoading(true);
      await Axios.postMasters(data)
        .then((response) => {
          this.showHideLoading();
          this.cleanRejectionsForm();
          this.cutting = false;
          if (showAlert) {
            SweetAlert.success(response.data.message);
          }
        })
        .catch((error) => {
          this.isSaveAll = false;
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    },

    /* saveAll() {
      if (this.validateCuttingForm(false)) {
        console.log('entro????');
        if (
          this.rejectionsForm.lots_rejections_sel[0] === undefined ||
          this.rejectionsForm.lots_rejections_sel[0] === ''
        ) {
        } else {
          this.saveRejections(false);
        }
        SweetAlert.success('Datos almacenados exitosamente');
      }
    }, */

    async saveAll() {
      try {
        // Esperar que las validaciones de cutting pasen
        const isValid = await this.validateCuttingForm(false);

        // Si las validaciones de cutting pasan
        if (isValid) {
          console.log('Validaciones de cutting completas, guardando datos...');

          // Validar y guardar los rechazos si existen
          if (
            this.rejectionsForm.lots_rejections_sel[0] !== undefined &&
            this.rejectionsForm.lots_rejections_sel[0] !== ''
          ) {
            await this.saveRejections(false); // Asegúrate de que saveRejections sea asíncrono si corresponde
          }

          SweetAlert.success('Datos almacenados exitosamente');
        }
      } catch (error) {
        // Si hubo errores en validateCuttingForm, este bloque los manejará
        console.error('Error al guardar:', error);
      }
    },

    loadCuttings() {
      this.showHideLoading(true);

      Promise.all([
        Axios.getMasters(`farms/farms/lots/${this.farm_id}`),
        Axios.getMasters(`cutting/legumecuts/${this.date_sel}/${this.farm_id}`),
        Axios.getMasters(
          `cutting/legumecuts/rejections/${this.date_sel}/${this.farm_id}`
        ),
      ])
        .then(([lotsResponse, cuttingResponse, cuttingRejectionResponse]) => {
          this.lots = lotsResponse.data.data;

          const cuttingRes = cuttingResponse.data.data;
          if (
            cuttingRes &&
            cuttingRes.lots_sel &&
            cuttingRes.lots_sel.length > 0
          ) {
            this.has_details = true;
            this.fruit_harvest_header_id = cuttingRes.header_id;
            this.cuttingForm = {
              ...this.cuttingForm,
              lots_sel: cuttingRes.lots_sel,
              crop_varieties_sel: cuttingRes.crop_varieties_sel,
              covered_area: cuttingRes.covered_area,
              gross_weight: cuttingRes.gross_weight,
              net_weight: cuttingRes.net_weight,
              nCutting: cuttingRes.lots_sel.length,
            };

            this.lotsData = [];
            for (let i = 0; i < cuttingRes.lots_sel.length; i++) {
              this.lotsData.push({
                id: cuttingRes.lots_sel[i],
                crop_variety: cuttingRes.crop_varieties_sel
                  ? cuttingRes.crop_varieties_sel[i] || null
                  : null,
                covered_area: cuttingRes.covered_area
                  ? cuttingRes.covered_area[i] || 0
                  : 0,
                gross_weight: cuttingRes.gross_weight
                  ? cuttingRes.gross_weight[i] || 0
                  : 0,
                net_weight: cuttingRes.net_weight
                  ? cuttingRes.net_weight[i] || 0
                  : 0,
              });
            }
          }

          const cuttingRejectionRes = cuttingRejectionResponse.data.data;

          if (
            cuttingRejectionRes &&
            cuttingRejectionRes.lots_rejections_sel &&
            cuttingRejectionRes.lots_rejections_sel.length > 0
          ) {
            this.has_rejections = true;
            this.fruit_harvest_header_id = cuttingRes.header_id;
            this.rejectionsForm = {
              ...this.rejectionsForm,
              lots_rejections_sel: cuttingRejectionRes.lots_rejections_sel,
              rejections_sel: cuttingRejectionRes.rejections_sel,
              weight: cuttingRejectionRes.weight,
              nCuttingRejections:
                cuttingRejectionRes.lots_rejections_sel.length,
            };

            this.lotsRejectionsData = [];
            for (
              let i = 0;
              i < cuttingRejectionRes.lots_rejections_sel.length;
              i++
            ) {
              this.lotsRejectionsData.push({
                id: cuttingRejectionRes.lots_rejections_sel[i],
                rejection_id: cuttingRejectionRes.rejections_sel
                  ? cuttingRejectionRes.rejections_sel[i] || null
                  : null,
                weight: cuttingRejectionRes.weight
                  ? cuttingRejectionRes.weight[i] || 0
                  : 0,
              });
            }
          }

          this.showHideLoading();
          this.cutting = true;
        })
        .catch((error) => {
          this.cutting = true;
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    deleteCuttingDetails() {
      if (this.has_details) {
        SweetAlert.delete('eliminar detalles de captura').then((result) => {
          if (result.value) {
            let data = {
              id: this.fruit_harvest_header_id,
              route: `cutting/legumecuts/delete`,
            };
            Axios.destroyMaster(data)
              .then((response) => {
                this.showHideLoading();
                this.cleanForm();
                this.cutting = false;
                SweetAlert.success(response.data.message);
              })
              .catch((error) => this.showMessageErrors(error));
          }
        });
      } else {
        SweetAlert.warning('No hay registro que eliminar');
      }
    },

    deleteRejectionDetails() {
      if (this.has_rejections) {
        SweetAlert.delete('eliminar rechazo de captura').then((result) => {
          if (result.value) {
            let data = {
              id: this.fruit_harvest_header_id,
              route: `cutting/legumecuts/rejections/delete`,
            };
            Axios.destroyMaster(data)
              .then((response) => {
                this.showHideLoading();
                this.cleanForm();
                this.cutting = false;
                SweetAlert.success(response.data.message);
              })
              .catch((error) => this.showMessageErrors(error));
          }
        });
      } else {
        SweetAlert.warning('No hay registro que eliminar');
      }
    },
  },

  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      Axios.getMasters('farms/farms/onlyfruit')
        .then((response) => {
          this.farms = response.data.data;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });

      Axios.getMasters('cropvarieties')
        .then((response) => {
          this.cropVarieties = response.data.data;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });

      Axios.getMasters('rejecteds/causes')
        .then((response) => {
          this.rejections = response.data.data;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('cutting');
  },

  destroyed() {
    this.deselectedItemOnMenu('cutting');
  },
};
</script>
<style>
.card .table:not(.not-last-td) thead th:last-child {
  display: revert !important;
}
</style>
